export enum CalculatorHTMMode {
    Direct = 'Direct',
    HTM = 'HTM'
}

export enum CalculatorAdvancedMode {
    Simple = 'Summary Version',
    Advanced = 'Advanced Version'
}
